export default "__VITE_ASSET__985009b6__"